module.exports = __webpack_public_path__ + "898a4357a3c85eedc64d2209fde19089.svg";